import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getTermsAndCondtions, updateTermsAndCondtions } from "../../../redux/actions/contentAction";

export default function Index() {
    const dispatch = useDispatch();

    const [termsAndCondtionsData, setTermsAndConditionsData] = useState({});

    useEffect(() => {
        dispatch(getTermsAndCondtions(setTermsAndConditionsData));
    }, [dispatch]);

    const updateTermsAndCondtionsData = () => {
        dispatch(updateTermsAndCondtions(termsAndCondtionsData, setTermsAndConditionsData));
    };

    return {
        termsAndCondtionsData,
        setTermsAndConditionsData,
        dispatch,
        updateTermsAndCondtionsData,
    };
}
